"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconProps = exports.iconMap = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _add = _interopRequireDefault(require("./svgs/add"));
var _check_in = _interopRequireDefault(require("./svgs/check_in"));
var _check_out = _interopRequireDefault(require("./svgs/check_out"));
var _close = _interopRequireDefault(require("./svgs/close"));
var _drop_down = _interopRequireDefault(require("./svgs/drop_down"));
var _open_application = _interopRequireDefault(require("./svgs/open_application"));
var _search = _interopRequireDefault(require("./svgs/search"));
var _help_support = _interopRequireDefault(require("./svgs/help_support"));
var _information = _interopRequireDefault(require("./svgs/information"));
var _messages = _interopRequireDefault(require("./svgs/messages"));
var _my_access = _interopRequireDefault(require("./svgs/my_access"));
var _my_approval = _interopRequireDefault(require("./svgs/my_approval"));
var _my_request = _interopRequireDefault(require("./svgs/my_request"));
var _notification_icon = _interopRequireDefault(require("./svgs/notification_icon"));
var _admin_ = _interopRequireDefault(require("./svgs/admin_1"));
var _admin_2 = _interopRequireDefault(require("./svgs/admin_2"));
var _admin_3 = _interopRequireDefault(require("./svgs/admin_3"));
var _admin_4 = _interopRequireDefault(require("./svgs/admin_4"));
var _admin_5 = _interopRequireDefault(require("./svgs/admin_5"));
var _admin_6 = _interopRequireDefault(require("./svgs/admin_6"));
var _excluded = ["height", "name", "size", "width"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var iconMap = {
  add: _add["default"],
  admin1: _admin_["default"],
  admin2: _admin_2["default"],
  admin3: _admin_3["default"],
  admin4: _admin_4["default"],
  admin5: _admin_5["default"],
  admin6: _admin_6["default"],
  checkIn: _check_in["default"],
  checkOut: _check_out["default"],
  close: _close["default"],
  dropDown: _drop_down["default"],
  helpSupport: _help_support["default"],
  information: _information["default"],
  messages: _messages["default"],
  myAccess: _my_access["default"],
  myApproval: _my_approval["default"],
  myRequest: _my_request["default"],
  notificationIcon: _notification_icon["default"],
  openApplication: _open_application["default"],
  search: _search["default"]
};
exports.iconMap = iconMap;
var Icon = function Icon(props) {
  var height = props.height,
    name = props.name,
    size = props.size,
    width = props.width,
    additionalIconProps = _objectWithoutProperties(props, _excluded);
  var IconComponent = iconMap[name];
  var sizing = size ? {
    width: size,
    height: size
  } : {
    width: width,
    height: height
  };
  if (!IconComponent) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(IconComponent, _extends({}, sizing, additionalIconProps));
};
Icon.propTypes = {
  width: _propTypes["default"].number,
  name: _propTypes["default"].oneOf(Object.keys(iconMap)),
  height: _propTypes["default"].number,
  color: _propTypes["default"].string,
  id: _propTypes["default"].string,
  size: _propTypes["default"].number
};
var _default = Icon;
exports["default"] = _default;
var iconProps = {
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  color: _propTypes["default"].string,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  id: _propTypes["default"].string
};
exports.iconProps = iconProps;